import React, {Component} from 'react';
import {Form, ErrorContainer} from 'form';

import '../../sass/form/checkbox.scss';

class Checkbox extends Component
{
    constructor(props) {
        super(props);
        this.state = {
            id: ''
        };
    }

    componentWillMount() {
        let id = 'prefix-';

        if (!Date.now) {
            id += new Date().getTime()
        } else {
            id += Date.now();
        }

        this.setState({id});
    }

    render()
    {
        const {
            checked,
            onChange,
            children
        } = this.props;

        const {
            id
        } = this.state;

        return (
            <div className="forms-checkbox">
                <input id={id} type="checkbox" checked={(checked)} onChange={(e) => onChange(e)} />
                <label htmlFor={id} className="checkbox_label">{children}</label>
            </div>
        )
    }
}


export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/form/Checkbox.js